module.exports = __webpack_public_path__ + "img/checked.39cd8d83.png";